import { ProfileContainer } from '../../modules/profileContainer/ProfileContainer';

export const Profile = ProfileContainer;
